import React from "react";
import { useTranslation } from "react-i18next";
import { Star } from "lucide-react";

import { Card, CardContent } from "../ui/card";

const testimonials = [
  { key: "ana", name: "Ana Paula Silva", location: "São Paulo, SP", rating: 5 },
  { key: "carlos", name: "Carlos Eduardo", location: "Rio de Janeiro, RJ", rating: 5 },
  { key: "mariana", name: "Mariana Costa", location: "Curitiba, PR", rating: 5 },
] as const;

export function Testimonials() {
  const { t } = useTranslation();

  return (
    <section className="bg-white py-16 sm:py-24">
      <div className="container mx-auto px-4">
        <div className="mb-10 text-center sm:mb-16">
          <h2 className="mb-4 text-3xl font-bold text-slate-900 sm:text-4xl md:text-5xl">
            {t("testimonials.title")} <span className="text-primary">{t("testimonials.highlight")}</span>
          </h2>
          <p className="mx-auto max-w-2xl text-lg text-slate-600">{t("testimonials.subtitle")}</p>
        </div>

        <div className="mx-auto grid max-w-6xl grid-cols-1 gap-6 sm:gap-8 md:grid-cols-3">
          {testimonials.map((testimonial) => (
            <Card
              key={testimonial.key}
              className="border-slate-100 bg-slate-50/30 transition-shadow hover:border-primary/20 hover:shadow-xl"
            >
              <CardContent className="pt-8">
                <div className="mb-4 flex gap-1" aria-label={`${testimonial.rating}/5`}>
                  {Array.from({ length: testimonial.rating }).map((_, i) => (
                    <Star key={i} className="h-5 w-5 fill-amber-400 text-amber-400" />
                  ))}
                </div>
                <p className="mb-6 italic leading-relaxed text-slate-600">
                  "{t(`testimonials.items.${testimonial.key}`)}"
                </p>
                <div>
                  <p className="font-bold text-slate-900">{testimonial.name}</p>
                  <p className="text-sm text-slate-500">{testimonial.location}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
